import { Api } from "../../modules";

export const sendFeedback = async (content: string) => {
    const url = "/feedback";
    await Api.url(url)
        .retries(0)
        .useSignal()
        .throwOnAbort()
        .track({ name: "core.feedbackService.sendFeedback" })
        .post({ content });
};
